import React, { useState, useRef, useEffect } from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import "../styles/FloatingChat.css";

// WhatsApp number
const WA_NUMBER = "919843222262";

// Contact Numbers
const PHONE_NUMBERS = [
  {
    label: "Sales Team",
    number: "+91 98432 22262",
    link: "tel:+919843222262",
  },
  {
    label: "Support Team",
    number: "+91 98765 43210",
    link: "tel:+919876543210",
  },
];

export default function FloatingChat() {
  const [showPhones, setShowPhones] = useState(false);

  return (
    <div className="kkb-chat-wrapper">
      {/* WhatsApp Button */}
      <div className="kkb-fab-container">
        <a
          href={`https://wa.me/${WA_NUMBER}?text=Hi KKB Store, I'm interested in your products.`}
          target="_blank"
          rel="noreferrer"
          className="kkb-fab whatsapp"
          title="Chat on WhatsApp"
          aria-label="Chat on WhatsApp"
        >
          <FaWhatsapp size={28} />
        </a>
      </div>

      {/* Phone Button */}
      <div className="kkb-fab-container phone-wrapper">
        {/* Phone Options */}
        {showPhones && (
          <div className="kkb-phone-options">
            {PHONE_NUMBERS.map((phone, index) => (
              <a key={index} href={phone.link} className="kkb-phone-option">
                <span>{phone.label}</span>
                <strong>{phone.number}</strong>
              </a>
            ))}
          </div>
        )}

        {/* Phone FAB */}
        <button
          className="kkb-fab phone"
          onClick={() => setShowPhones(!showPhones)}
          title="Call Us"
          aria-label="Call Us"
        >
          <FaPhoneAlt size={22} />
        </button>
      </div>
    </div>
  );
}
